var createCache = function createCache(options) {
  var cache = {
    get: function get(key) {
      var localStorageValue = localStorage.getItem([options.prefix, key].join('/'));
      return localStorageValue ? JSON.parse(localStorageValue) : null;
    },
    set: function set(key, value) {
      try {
        localStorage.setItem([options.prefix, key].join('/'), JSON.stringify(value));
        return true;
        // eslint-disable-next-line
      } catch (_error) {
        return false;
      }
    },
    unset: function unset(key) {
      localStorage.removeItem([options.prefix, key].join('/'));
    }
  };
  return cache;
};

var version = "12.3.6";

export { createCache as default, version };
